exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Xbgn{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2Aizy,._2Xbgn{display:-webkit-box;display:-ms-flexbox;display:flex}._2Aizy{width:340px;height:90px;padding:20px;background:#fff;border-radius:5px;margin-bottom:20px}._2Aizy:not(:nth-child(3n)){margin-right:20px}._2aEl_{margin-right:20px;width:50px;height:50px;background:#ffd906;border-radius:50px}._1qObY,._2aEl_{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1qObY{font-weight:500;font-size:16px;width:230px}@media screen and (max-width:768px){._2Aizy{width:auto;height:90px;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._2Aizy:not(:nth-child(3n)){margin-right:0}}", ""]);

// exports
exports.locals = {
	"root": "_2Xbgn",
	"item": "_2Aizy",
	"icon": "_2aEl_",
	"text": "_1qObY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/Article/Leasing/LeasingWhyAbUa/LeasingWhyAbUa.css
// module id = 3259
// module chunks = 21